import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceLocatorService } from '@ncs/ncs-lib';
import { UiformBaseComponent } from '../uiform-base/uiform-base.component';
import { DomSanitizer, SafeUrl, SafeHtml } from '@angular/platform-browser';
import {
  CropperPosition,
  Dimensions,
  ImageCroppedEvent,
  ImageTransform,
} from 'ngx-image-cropper';
import { Editor, Toolbar, toHTML } from 'ngx-editor';

@Component({
  selector: 'app-uiform-edit',
  templateUrl: './uiform-edit.component.html',
  styleUrls: ['./uiform-edit.component.css'],
})
export class UiformEditComponent
  extends UiformBaseComponent
  implements OnChanges, AfterViewInit
{
  public usecaseSchema: any = {};
  public attributeId: number = 0;
  public commentList: any = [];
  public attachmentList: any = [];
  public appAttachmentInfo: any;
  public appCommentInfo: any;
  componentFlag: boolean = true;

  public entryform: any = {
    data: { id: 0 }, //form data
  };

  public searchform: any = {
    data: {},
  };

  isHovered: boolean = false;

  onMouseEnter() {
    this.isHovered = true;
  }

  onMouseLeave() {
    this.isHovered = false;
  }

  read: number = 0;
  update: number = 0;
  isDelete: number = 0;
  create: number = 0;
  htmlContentMap: { [key: string]: SafeHtml } = {};
  checkExpression: any;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private router: Router,
  ) {
    super(locator, route);
    let _self = this;
    if (route.snapshot.paramMap.get('appId'))
      _self.appId = Number(route.snapshot.paramMap.get('appId'));

    this.checkExpression = _self.id;

    if (route.snapshot.paramMap.get('usecaseId'))
      _self.usecaseId = Number(route.snapshot.paramMap.get('usecaseId'));

    if (route.snapshot.paramMap.get('uiformId'))
      _self.uiformId = Number(route.snapshot.paramMap.get('uiformId'));

    if (route.snapshot.paramMap.get('id'))
      _self.id = Number(route.snapshot.paramMap.get('id'));

    _self.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  override async ngOnInit() {
    let _self = this;
    _self.checkUserAccess(this.uiformId);
    _self.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        if (_self.uiformId)
          this.get(_self.uiformId, function () {
            _self.usecaseId = _self.form.data.userstoryId;
            _self.getUsecaseSchema(false, () => {
              _self.getUiformData(_self.id);
              _self.checkBtnRight();
              _self.cdRef.detectChanges();
              _self.getCommentList(_self.id);
              _self.getattachmentList(_self.id);
              _self.setDefaultvalue();
              _self.setHtmlEditor();
              _self.checklocation();
            });
          });
      });
  }

  checklocation() {
    var _self = this;
    _self.usecaseAttributes.map((item: any) => {
      if (item.type == 'location') {
        _self.prepareLocationField(item.code);
      }
    });
  }

  addRulesEvents(): void {
    if (!this.form?.data?.fields) return;

    let fields = this.form.data.fields.filter(
      (field: any) => field.rule && field.rule !== '',
    );

    fields.forEach((field: any) => {
      const inputElement = document.querySelector(`input[id="${field.code}"]`);

      if (inputElement) {
        this.renderer.listen(inputElement, 'change', (event: Event) => {
          this.handleRuleExecute(field, event);
        });

        this.renderer.listen(inputElement, 'input', (event: Event) => {});
      } else {
        console.error(`Input element with id "${field.code}" not found`);
      }
    });
  }

  handleRuleExecute(field: any, event: any) {
    let _self = this;
    let ruleData: any;
    _self.entryform['error'] = [];
    _self.entryform['message'] = '';
    _self.entryform['inputerror'] = [];
    ruleData = { ..._self.entryform.data };
    ruleData['collectionName'] = _self.usecase['collectionName'];

    let url: any =
      _self.locator.config.get('endpoint.application.rules') +
      '/' +
      'execute/' +
      field.rule;

    _self.locator.http.post(url, ruleData, function (res: any, error: any) {
      if (error) {
        return;
      }
      _self.entryform.data = { ..._self.entryform.data, ...res.result };
      _self.entryform['error'] = !res.success;
      _self.entryform['message'] = res.message;
      _self.entryform['inputerror'] = Object.values(
        res.result['inputerror'],
      ).join(', ');
    });
  }

  checkRuleExecute(code: any) {
    let fields = this.form.data.fields.filter(
      (field: any) => field?.rule && field?.rule !== '' && field?.code == code,
    );
    fields.forEach((field: any) => {
      this.handleRuleExecute(field, null);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['form'] && this.form?.data?.fields) {
      //this.addRulesEvents();
    }
  }

  ngAfterViewInit() {}

  private listenerAdded = false;

  ngAfterViewChecked(): void {
    if (!this.listenerAdded) {
      setTimeout(() => {
        this.addRulesEvents();
        this.addParentFilter();
      }, 1000);

      this.listenerAdded = true;
    }
  }

  override populateForm(form: any, data: any): void {
    super.populateForm(form, data);

    if (data.groupLabels) {
      form.groupLabels = data.groupLabels;
    }
    if (data.childFormList) {
      form.childFormList = data.childFormList;
    }
  }

  getRows(field: any) {
    if (field['rowsize'] && field['rowsize'] > 1 && field['rowsize'] < 4) {
      return 'row-size-' + field['rowsize'];
    }
    return '';
  }

  // getColums(columns: any, field: any) {
  //   let size = 12;
  //   if (columns) {
  //     size = 12 / columns;
  //   }
  //   if (field['colsize'] && field['colsize'] > 0) {
  //     let tempSize = size * field['colsize'];
  //     if (tempSize <= 12) {
  //       return tempSize;
  //     } else {
  //       return 12;
  //     }
  //   }
  //   return size;
  // }

  getColums(columns: any, field: any): string {
    let size = 12;

    // base grid size
    if (columns && columns > 0) {
      size = 12 / columns;
    }

    // if field has custom colsize, apply multiplier
    if (field['colsize'] && field['colsize'] > 0) {
      let tempSize = size * field['colsize'];
      size = tempSize <= 12 ? tempSize : 12;
    }

    // round to nearest integer (Bootstrap expects whole numbers)
    size = Math.round(size);

    // full width on mobile (col-12), responsive on md+
    return `col-12 col-md-${size}`;
  }

  getDescription(field: any) {
    if (field['description']) {
      return field['description'];
    }

    return field['label'];
  }
  gettitle(field: any) {
    if (field['description']) {
      return this.form.data['description'];
    }
    return this.form.data['title'];
  }

  getAttributeLable(lable: string) {}

  public attributeList: any = [];

  /**
   * only filter attribute that exist in usecase
   * @param data = responce get from server
   */
  cleanAndSetData(data: any) {
    let _self = this;
    const sanitizedItem: any = {};

    _self.usecaseAttributes.forEach((attr: any) => {
      let key = attr['code'];

      if (key in data) {
        let value = data[key];

        if (attr.type === 'dateandtime' && value) {
          try {
            const utcDate = new Date(value);
            const d = new Date(utcDate);
            const year = d.getFullYear();
            const month = (d.getMonth() + 1).toString().padStart(2, '0');
            const day = d.getDate().toString().padStart(2, '0');
            const hours = d.getHours().toString().padStart(2, '0');
            const minutes = d.getMinutes().toString().padStart(2, '0');
            const localISO = `${year}-${month}-${day}T${hours}:${minutes}`;

            sanitizedItem[key] = localISO;
          } catch (err) {
            sanitizedItem[key] = value;
          }
        } else if (attr.type === 'idate' && value) {
          try {
            const utcDate = new Date(value);
            const d = new Date(utcDate);
            const year = d.getFullYear();
            const month = (d.getMonth() + 1).toString().padStart(2, '0');
            const day = d.getDate().toString().padStart(2, '0');
            const hours = d.getHours().toString().padStart(2, '0');
            const minutes = d.getMinutes().toString().padStart(2, '0');
            const localISO = `${year}-${month}-${day}`;

            sanitizedItem[key] = localISO;
          } catch (err) {
            sanitizedItem[key] = value;
          }
        } else if (attr.type === 'itime' && value) {
          try {
            const utcDate = new Date(value);
            const d = new Date(utcDate);
            const hh = d.getHours().toString().padStart(2, '0');
            const mm = d.getMinutes().toString().padStart(2, '0');
            const localISO = `${hh}:${mm}`;
            sanitizedItem[key] = localISO;
          } catch (err) {
            sanitizedItem[key] = value;
          }
        } else {
          sanitizedItem[key] = value;
        }
      }
    });

    if ('id' in data) {
      sanitizedItem['id'] = data['id'];
    }
    _self.entryform['data'] = sanitizedItem;
  }

  /**
   * Get usecase record by primary key
   * @param id
   */
  public getUiformData(id: number | null) {
    let _self = this;
    if (!id || !(id > 0)) {
      return;
    }
    let url = _self.apiurl + '/get/' + id;
    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.cleanAndSetData(res.result['data']);
    });
  }

  combobox: any = [];
  public saveUiformData() {
    console.log();
    let _self = this;
    _self.entryform['error'] = [];
    _self.entryform['message'] = '';
    _self.entryform['inputerror'] = [];
    const keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    const roleId = localStorage.getItem(keySuffix + 'roleId');
    let url = _self.urlRewrite(
      _self.getAPIBaseUrl(_self.form.data.code + '/saveForm/' + roleId),
    );
    _self.combobox = _self.usecaseAttributes.filter(
      (item: any) => item.type === 'combobox',
    );
    const entryformLabels = Object.keys(_self.entryform['data']);

    let timeattributes = _self.usecaseAttributes.filter(
      (item: any) => item.type === 'itime',
    );
    let dateAndTime = _self.usecaseAttributes.filter(
      (item: any) => item.type == 'dateandtime',
    );

    // Trim only text & textarea fields
    const textAttributes = _self.usecaseAttributes.filter(
      (item: any) => item.type === 'text' || item.type === 'textarea',
    );

    // --- Create payload copy ---
    const filteredData = JSON.parse(JSON.stringify(_self.entryform['data']));

    dateAndTime.forEach((item: any) => {
      if (filteredData[item.code]) {
        filteredData[item.code] = new Date(
          filteredData[item.code],
        ).toISOString();
      }
    });

    textAttributes.forEach((attr: any) => {
      const key = attr.code;
      const value = filteredData[key];

      if (typeof value === 'string') {
        const trimmed = value.trim();

        // If only spaces → treat as null
        filteredData[key] = trimmed.length === 0 ? null : trimmed;
      }
    });

    timeattributes.forEach((item: any) => {
      if (entryformLabels?.includes(item.code)) {
        let value = filteredData[item.code];
        if (value && value.length === 5) {
          value = `1970-01-01T${value}:00`;
        }
        const utcIso = new Date(value).toISOString();
        filteredData[item.code] = utcIso;
      }
    });

    _self.combobox.forEach((item: any) => {
      if (entryformLabels?.includes(item.code)) {
        const entryValue = _self.entryform['data'][item.code];
        if (entryValue) {
          if (!item.values) {
            item.values = [];
          }

          if (!item.values.includes(entryValue)) {
            let isValid = true;

            if (item.regex) {
              const regex = new RegExp(item.regex);
              isValid = regex.test(entryValue);
            }

            if (isValid) {
              item.values.push(entryValue);
            }

            const payload = {
              label: item.label,
              type: item.type,
              userstoryId: item.userstoryId,
              id: item.id,
              values: item.values,
            };

            // Define API endpoint
            let url =
              _self.locator.config.get('endpoint.userstory.attributes') +
              '/save';

            // Make API call to save updated combobox
            _self.locator.http.post(
              url,
              payload,
              (res: any, error: boolean) => {
                if (error) {
                  alert('Server Error: ' + error);
                  return;
                }
              },
            );
          }
        }
      }
    });

    _self.entryform['data']['formDocId'] = _self.uiformId;
    _self.locator.http.post(
      url,
      filteredData,
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.entryform['error'] = !res.success;
        _self.entryform['message'] = res.message;
        _self.entryform['inputerror'] = res.result?.inputerror || {};
        if (res.result['inputerror']) {
          if (res.result['inputerror']['key']) {
            _self.entryform['message'] = res.result['inputerror']['key'];
          } else {
            _self.entryform['inputerror'] = res.result['inputerror'];
          }
        }
        if (res.success) {
          _self.entryform['data']['id'] = res.result['data']['id'];
          _self.cleanAndSetData(res.result['data']);
          _self.id = res.result['data']['id'];
          const hasImages =
            _self.imageFiles && Object.keys(_self.imageFiles).length > 0;
          const hasDocs =
            _self.docFiles && Object.keys(_self.docFiles).length > 0;

          if (hasImages && hasDocs) {
            _self
              .uploadImagesThenSaveForm(_self.imageFiles)
              .then(() => _self.uploadImagesThenSaveForm(_self.docFiles))
              .then(() => _self.finalSubmitForm())
              .catch((err) => {
                alert('File upload failed.');
              });
          } else if (hasImages) {
            _self
              .uploadImagesThenSaveForm(_self.imageFiles)
              .then(() => _self.finalSubmitForm())
              .catch((err) => {
                alert('Image upload failed.');
              });
          } else if (hasDocs) {
            _self
              .uploadImagesThenSaveForm(_self.docFiles)
              .then(() => _self.finalSubmitForm())
              .catch((err) => {
                alert('Document upload failed.');
              });
          }
        }
      },
    );
  }

  uploadImagesThenSaveForm(Files: any): Promise<void> {
    let _self = this;

    const fileKeys = Object.keys(Files);
    const uploadPromises = fileKeys.map((code) => {
      const file = Files[code];
      return _self.uploadFileToServer(file, code, 0); // Assume this returns a Promise
    });

    return Promise.all(uploadPromises).then((responses) => {
      responses.forEach((response: any, index: number) => {
        const imageId = response.result?.data?.imageId;
        if (imageId) {
          _self.entryform['data'][fileKeys[index]] = imageId;
        }
      });
    });
  }
  // Final function to submit the form with image IDs
  finalSubmitForm() {
    let _self = this;
    const url = _self.urlRewrite(
      _self.getAPIBaseUrl(_self.form.data.code + '/saveForm'),
    );

    let timeattributes = _self.usecaseAttributes.filter(
      (item: any) => item.type === 'itime',
    );
    const entryformLabels = Object.keys(_self.entryform['data']);
    let dateAndTime = _self.usecaseAttributes.filter(
      (item: any) => item.type == 'dateandtime',
    );
    dateAndTime.forEach((item: any) => {
      if (entryformLabels?.includes(item.code)) {
        const value = _self.entryform['data'][item.code];
        const utcIso = new Date(value).toISOString();
        _self.entryform['data'][item.code] = utcIso;
      }
    });

    timeattributes.forEach((item: any) => {
      if (entryformLabels?.includes(item.code)) {
        let value = _self.entryform['data'][item.code];
        if (value && value.length === 5) {
          value = `1970-01-01T${value}:00`;
        }
        const utcIso = new Date(value).toISOString();
        _self.entryform['data'][item.code] = utcIso;
      }
    });
    _self.locator.http.post(
      url,
      _self.entryform['data'],
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error: ' + error);
          return;
        }

        _self.entryform['error'] = !res.success;
        _self.entryform['message'] = res.message;

        if (res.success) {
          _self.entryform['data']['id'] = res.result['data']['id'];
          _self.id = res.result['data']['id'];
          _self.cleanAndSetData(res.result['data']);
        } else {
          alert('Error while submitting form with image IDs');
        }
      },
    );
  }

  toggleDropdown(e: any) {
    if (
      e['readOnly'] ||
      (e.allowChangeAfterInitial == 1 && this.entryform.data['id'] > 0)
    ) {
      return;
    }
    e.isDropdownOpen = !e.isDropdownOpen;
  }

  onCheckboxChange(e: any, option: any, event: any) {
    event.stopPropagation();
    if (!this.entryform.data[e.code]) {
      this.entryform.data[e.code] = [];
    }
    if (event.target.checked) {
      if (!this.entryform.data[e.code].includes(option)) {
        this.entryform.data[e.code].push(option);
      }
    } else {
      this.entryform.data[e.code] = this.entryform.data[e.code].filter(
        (o: any) => o !== option,
      );
    }
    this.onChange(e, this.entryform.data[e.code]);
  }

  getSelectedText(e: any) {
    const value = this.entryform.data[e.code];
    if (e['multipleSelect'] == 1 && Array.isArray(value) && value.length) {
      return value.join(', ');
    }
    return '';
  }

  public onChange(e: any, val: any) {
    const list = this.form.preload[e['primaryUsecase']];
    const col = e['depAttribute'];
    const found = list?.find((item: any) => item.id == val.id);

    if (found) {
      this.entryform.data[col] = found.name ?? found._val;
    } else {
      this.entryform.data[col] = undefined;
    }

    // Trigger dependency filter if applicable
    const dep = this.usecase?.parentUsecaseDependency?.[e['primaryUsecase']];
    if (dep) {
      this.primaryUsecaseDependencyFilter(dep, `${e.code}=${val.id}`);
    }

    this.evaluateExpressionFieldsBeforeSave();
  }

  public primaryUsecaseDependencyFilter(data: any, val: string) {
    const [appCode, codes] = (data['code'] ?? '').toString().split('.');
    const url = `${this.locator.config.get('endpoint.api.v1')}/${appCode}/${codes}/preloadData`;
    const searchParams = { val };
    this.locator.http.post(url, searchParams, (res: any, error: boolean) => {
      if (error) {
        this.entryform['error'] = true;
        this.entryform['message'] = error;

        return;
      }
      this.form.preload[data['code']] = res.result[data['code']];
    });
  }

  onSave() {
    //this.entryform.data['uiformId'] = this.form.data['id'];
    this.saveUiformData();
  }

  onCancel() {
    // nothing do
    // this.forward('/uiform/' + this.uiformId);
    this.resetUiformData();
    this.setDefaultvalue();
  }

  onList() {
    // go to list page
    this.forward('/uiformlist/' + this.uiformId);
  }

  onDelete() {
    this.deleteUseCaseData(this.id, () => {
      this.resetUiformData();
      this.setDefaultvalue();
      setTimeout(() => {
        this.onList();
      }, 1000);
    });
  }

  onNew() {
    this.resetUiformData();
    this.setDefaultvalue();
  }

  resetUiformData() {
    let _self = this;
    _self.entryform['data'] = {};
    _self.entryform['inputerror'] = {};
    _self.entryform['message'] = '';
    _self.entryform['error'] = false;
  }

  getAttributeByUniqueId(fieldId: number) {
    return this.usecaseAttributes.find(
      (attr: any) =>
        attr.id === fieldId && attr['system'] != 1 && attr['unique'] == 1,
    );
  }

  getSearchField() {
    let _self = this;
    if (_self.usecase?.unique) {
      const uniqueCodes = new Set(_self.usecase.unique.flat());
      const result = _self.usecaseAttributes.filter(
        (attr: any) =>
          _self.form.data['fields'].some(
            (field: any) => field.id === attr.id,
          ) &&
          (uniqueCodes.has(attr.code) ||
            (attr['system'] != 1 && attr['unique'] == 1)),
      );
      return result;
    }
    return [];
  }

  isAttributeHaveUnique() {
    return this.usecaseAttributes.find((attr: any) => attr['unique'] == 1);
  }

  onValueChange(e: any, value: string) {
    this.searchform.data[e.code] =
      e.type === 'number' ? parseFloat(value) : value;
  }

  onReferenceValueChange(e: any, value: string) {
    this.searchform.data[e.code] = parseFloat(value);
  }

  /**
   * get usecase records list
   */
  public getSearchUiformDataByList() {
    let _self = this;
    let url = _self.getAPIBaseUrl() + '/search';

    _self.entryform['error'] = false;
    _self.entryform['message'] = '';

    let searchdata = Object.fromEntries(
      Object.entries(this.searchform.data).filter(
        ([_, value]) =>
          value !== null &&
          !Number.isNaN(value) &&
          value !== '' &&
          value !== 'undefined' &&
          value !== undefined,
      ),
    );
    _self.locator.http.post(
      url,
      searchdata,
      function (res: any, error: boolean) {
        if (error) {
          return;
        }
        _self.entryform['error'] = !res.success;
        _self.entryform['message'] = res.message;

        if (res.result['data'].length > 0 && res.result['data'].length === 1) {
          _self.entryform.data = res.result['data'][0];
        } else if (res.result['data'].length > 1) {
          _self.entryform['error'] = false;
          _self.entryform['message'] =
            'multiple record found. redirect to list';
          localStorage.setItem(
            'uiform_listdata',
            JSON.stringify(res.result['data']),
          );
          setTimeout(() => {
            _self.forward('/uiformlist/' + _self.uiformId);
          }, 500);
        } else {
          _self.entryform['error'] = true;
          _self.entryform['message'] = 'No record found';
          _self.entryform.data = {};
        }
      },
    );
  }

  filterBtnAccess() {
    if (this.update !== 1 && this.entryform.data['id'] > 0) {
      this.form.data.buttons = this.form.data.buttons.filter(
        (attr: any) => attr['name'] !== 'save',
      );
    }
    return this.form.data.buttons;
  }

  fieldButtonSubmit(btn: any): void {
    if (!btn) {
      console.error('Invalid button configuration:', btn);
      return;
    }

    const type = btn.type || this.detectLegacyType(btn);

    switch (type) {
      case 'system':
        this.handleSystemButton(btn.name);
        break;

      case 'form':
        if (!btn.url) {
          console.error('Missing URL for navigation button:', btn);
          return;
        }
        this.router.navigateByUrl(btn.url, {
          state: { tokenAccess: true },
        });
        break;
      case 'report':
        if (!btn.url) {
          console.error('Missing URL for navigation button:', btn);
          return;
        }
        this.router.navigateByUrl(btn.url);
        break;

      case 'url':
        if (!btn.url) {
          console.error('Missing URL for external button:', btn);
          return;
        }

        const target = btn.target === '_blank' ? '_blank' : '_self';
        window.open(btn.url, target);
        break;

      default:
        console.warn('Unknown button type:', btn);
    }
  }

  private handleSystemButton(name: string): void {
    switch (name) {
      case 'save':
        this.onSave();
        break;

      case 'cancel':
        this.onCancel();
        break;

      case 'list':
        this.onList();
        break;

      case 'delete':
        this.onDelete();
        break;

      case 'new':
        this.onNew();
        break;

      default:
        console.warn('Unknown system action:', name);
    }
  }

  getDefaultColums(columns: any, field: any) {
    let size = 12;
    if (columns) {
      size = 12 / columns;
    }
    return 12;
  }

  getTruncateLimit(columns?: number): number {
    if (!columns || columns <= 1) return 150;
    if (columns === 2) return 70;
    if (columns === 3) return 35;
    if (columns === 4) return 25;
    return 15;
  }

  public getInputError(name: string) {
    let _self = this;
    let errMsg = '';
    let ie = _self.entryform['inputerror'];
    if (ie && ie[name]) {
      errMsg = ie[name];
    }
    return errMsg;
  }

  /**
   * Upload Image
   * @param event
   */
  /**
   *
   * @param event
   * @param code
   * @param imageId
   */
  // public onFileChanged(event: any, code: string, imageId: any) {
  //   const fileObj = event.target.files[0];
  //   var _self = this;
  //   _self.showPreview(event);
  //   console.log(_self.form.data['code'])
  //   if (imageId === null || imageId === undefined) {

  //     imageId = 0;
  //   }
  //   let url = _self.getAPIBaseUrl("doc/" + _self.entryform.data['id'] + "/" + imageId + "/" + code);
  //   var param = {
  //     id: _self.id
  //   };
  //   this.locator.http.postMutipart(url, param, fileObj, function (res: any, error: any) {
  //     if (error) {
  //       alert(error);
  //       return;
  //     }
  //     _self.form.error = !res.success;
  //     _self.form.message = res.result.message;
  //     if (res.success) {
  //       _self.entryform['message'] = "file is uploaded";
  //       _self.entryform.data[code] = res.result.data[code];
  //       _self.changeDoc();
  //       _self.getDoc(_self.entryform.data[code]);

  //     }
  //   });
  //   console.log("fileObj  ", fileObj);
  // }

  public clearUniqueMessage(name: string) {
    let _self = this;
    let errMsg = '';
    _self.form['inputerror'][name] = '';
  }

  /**
   * Export data in PDF
   */
  public exportPDFData() {
    let _self = this;
    let url = _self.urlRewrite(
      _self.getAPIBaseUrl(
        'downloadpdf/' + _self.entryform.data['id'] + '/' + _self.uiformId,
      ),
    );
    //let endpoint = this.httpService.urlRewrite(url);
    _self.locator.http
      .getClient()
      .post(url, {}, { responseType: 'blob' })
      .subscribe(
        (data: any) => {
          _self.downloadDataAsFile(data, 'export.pdf');
        },
        (data: any) => {
          console.error(data);
        },
      );
  }

  /**
   * Downalod data as file
   * @param data
   * @param fileName
   */
  public downloadDataAsFile(data: any, fileName: string) {
    //Create a dynamic link and download file
    let file = new window.Blob([data], { type: data.type });
    const downloadAncher = document.createElement('a');
    downloadAncher.style.display = 'none';
    const fileURL = URL.createObjectURL(file);
    downloadAncher.href = fileURL;
    downloadAncher.download = fileName;
    downloadAncher.click();
  }

  /**
   * Share PDF by Email
   */
  public sharePdf() {
    let _self = this;

    // ✅ Reset previous state before sending the request
    _self.sform['error'] = null;
    _self.sform['message'] = null;

    let url = _self.getAPIBaseUrl(
      'sendForm/' + _self.entryform.data['id'] + '/' + _self.uiformId,
    );
    _self.locator.http.post(
      url,
      _self.sform.data,
      function (res: any, error: boolean) {
        if (error) {
          _self.sform['error'] = true;
          _self.sform['message'] = error;
          _self.btnDisable = false;
          return;
        }
        _self.sform['error'] = false;
        if (res.success) {
          _self.datavalidate = false;
          _self.btnDisable = true;
          _self.sform['message'] = res.message;
        }
      },
    );
  }

  resetShareForm() {
    let _self = this;
    _self.sform = {
      data: {},
    };
    // _self.datavalidate=false;
  }

  public sform: any = {
    data: {},
  };

  imagePreview: string | ArrayBuffer | null = null;

  /**
   * Get Thumbnail of the image
   * @param logo
   * @returns
   */
  getDocThumbnailImage(logo: any) {
    return this.getDocThumbnail(logo);
  }

  /**
   * Show preview of the image
   * @param event
   */
  // showPreview(event: Event) {
  //   const target = event.target as HTMLInputElement;
  //   const file = target.files ? target.files[0] : null;

  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       this.imagePreview = reader.result as string; // Cast result to string
  //     };
  //     reader.onerror = (error) => {
  //       console.error('Error loading file:', error); // Log any errors with FileReader
  //     };
  //     reader.readAsDataURL(file); // Convert the file to a Base64 URL
  //   } else {
  //     console.warn('No file selected');
  //   }
  // }

  // -----------------Image Crop Function--------------------------

  transformChange(transform: ImageTransform) {
    console.log('transform changed', transform);
  }

  moveLeft() {
    this.transform = {
      ...this.transform,
      translateH: this.transform.translateH! - 1,
    };
  }

  moveRight() {
    this.transform = {
      ...this.transform,
      translateH: this.transform.translateH! + 1,
    };
  }

  moveDown() {
    this.transform = {
      ...this.transform,
      translateV: this.transform.translateV! + 1,
    };
  }

  moveUp() {
    this.transform = {
      ...this.transform,
      translateV: this.transform.translateV! - 1,
    };
  }

  resetImage() {
    this.canvasRotation = 0;
    this.maintainAspectRatio = false;
    this.transform = {
      translateUnit: 'px',
      scale: 1,
      rotate: 0,
      flipH: false,
      flipV: false,
      translateH: 0,
      translateV: 0,
    };
  }

  updateRotation(rotate: number) {
    this.transform = {
      ...this.transform,
      rotate,
    };
  }

  toggleAspectRatio() {
    this.aspectRatio = this.aspectRatio === 4 / 3 ? 16 / 5 : 4 / 3;
  }

  // cancelCropping() {
  //   this.imageSize = false;
  //   this.fileError = false;
  //   // Logic to cancel cropping and reset the cropper
  //   this.resetCropper();
  // }
  public croppedImageFile: File | null = null;

  resetCropper() {
    this.imageChangedEvent = null;
    this.showCropper = false;
    this.croppedImage = '';
    this.imageId = '';
    this.croppedImageFile = null;
  }

  public imageId: any = 0;
  public imageCode: any;
  public imageName: any;
  /**
   * Upload Image
   * @param event
   * @param code
   * @param imageId
   */

  fileError: boolean = false;

  // imageSize: boolean = false;
  // dissmissModel: boolean = true;
  // public onFileChanged(event: any) {
  //   // Show the cropper
  //   const file = event.target.files[0];
  //   if (file) {
  //     const allowedTypes = [
  //       'image/jpeg',
  //       'image/jpg',
  //       'image/png',
  //       'image/gif',
  //     ];
  //     if (!allowedTypes.includes(file.type)) {
  //       this.fileError = true;
  //       return;
  //     }
  //   }
  //   const maxSize = 1 * 1024 * 1024; // 1 MB in bytes
  //   if (file.size > maxSize) {
  //     this.dissmissModel = false;
  //     this.imageSize = true;
  //     return;
  //   }
  //   this.fileChangeEvent(event);

  //   const fileObj = event.target.files[0];
  //   this.imageName = fileObj['name'];
  //   // this.imageId = imageId;
  //   //this.imageCode = code;
  // }

  resetFileInput(fileInput: HTMLInputElement): void {
    fileInput.value = ''; // Reset the file input
    this.imageName = null; // Clear the file name
  }

  imageData(code: string, imageId: any) {
    if (imageId === null || imageId === undefined || imageId === '') {
      imageId = 0;
    }

    this.imageId = imageId;
    this.imageCode = code;
  }

  getGroupsField(label: any) {
    return this.form.data.fields.filter((field: any) => field.group == label);
  }
  checkTime(group: any): boolean {
    const startRaw = group.allowedTimeStart;
    const endRaw = group.allowedTimeEnd;
    const startMeridian = group.allowedTimeStartMeridian;
    const endMeridian = group.allowedTimeEndMeridian;

    // If all are null/empty → treat as unrestricted
    if (!startRaw && !endRaw && !startMeridian && !endMeridian) {
      return true;
    }

    // If any required part is missing → restrict access
    if (!startRaw || !endRaw || !startMeridian || !endMeridian) {
      return false;
    }

    // Convert time string (hh:mm) and meridian into minutes
    const toMinutes = (timeStr: string, meridian: string): number | null => {
      const [hh, mm] = timeStr.split(':').map(Number);
      if (isNaN(hh) || isNaN(mm)) return null;

      let hour = hh;
      if (meridian === 'PM' && hh !== 12) hour += 12;
      if (meridian === 'AM' && hh === 12) hour = 0;

      return hour * 60 + mm;
    };

    const startMinutes = toMinutes(startRaw, startMeridian);
    const endMinutes = toMinutes(endRaw, endMeridian);

    // If invalid parsed time → restrict
    if (startMinutes === null || endMinutes === null) {
      return false;
    }

    // Get current time in minutes
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    // Check if current time falls within the allowed range
    return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
  }

  getFieldNotIngroup() {
    return (
      this.form?.data?.fields?.filter(
        (field: any) => !field?.group && field?.group == null,
      ) || []
    );
  }

  evaluateCondition(attr: any): boolean {
    try {
      if (attr['show']) {
        const condition = attr['show'] as string;
        const context = this.entryform?.data || {};

        // Ensure all variables in the condition are present in context
        const variableRegex = /\b([a-zA-Z_][a-zA-Z0-9_]*)\b/g;
        const variablesInCondition = new Set(condition.match(variableRegex));
        const contextKeys = Object.keys(context);

        // Add missing variables with value undefined
        for (const variable of variablesInCondition) {
          if (!contextKeys.includes(variable) && isNaN(Number(variable))) {
            context[variable] = undefined;
          }
        }
        const fn = new Function(
          ...Object.keys(context),
          `return ${condition};`,
        );
        const result = fn(...Object.values(context));
        return result;
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  groupFieldsByGroup(fields: any[]): { [key: string]: any[] } {
    return fields.reduce((acc, field) => {
      const group = field['group'] || 'Ungrouped'; // Default to 'Ungrouped' if no group name exists
      acc[group] = acc[group] || [];
      acc[group].push(field);
      return acc;
    }, {});
  }

  public minDate: string | null = null;
  public maxDate: string | null = null;

  /**
   * Min and Max Date
   * @param min
   * @param max
   * @param type
   * @returns
   */
  getDateMin(min: string, max: string, type: string) {
    if (type === 'date') {
      this.minDate = min;
      this.maxDate = max;
    }
  }

  /**
   * If Date clear change Form
   * @param event
   * @param code
   * @param type
   */
  onDateChange(event: any, code: string, type: string) {
    if (type === 'date') {
      const selectedDate = event.target.value;
      this.entryform.data[code] = selectedDate ? selectedDate : null;
    }
  }

  /***
   * Filter The ParentUsecase With Type
   */
  addParentFilter(): void {
    if (!this.form?.data?.fields) return;
    let fields = this.form.data.fields.filter(
      (field: any) => field.parentFilter && field.parentFilter !== '',
    );

    const code = fields[0]?.code;
    let matchingUsecase = null;
    let matchingKey = null;
    if (
      this.usecase.parentUsecases &&
      typeof this.usecase.parentUsecases === 'object'
    ) {
      for (const key of Object.keys(this.usecase.parentUsecases)) {
        const parentUsecase = this.usecase.parentUsecases[key];
        if (parentUsecase && parentUsecase.id === code) {
          matchingUsecase = parentUsecase;
          matchingKey = key;
          break;
        }
      }
    }

    if (matchingUsecase) {
      // this.preloadListData(matchingKey, fields[0]?.parentFilter);
    } else {
      console.log('Not found in parentUsecases');
    }
  }

  override getUsecasePreloadData() {
    let _self = this;
    let url = _self.apiurl + '/preloadServer/' + _self.uiformId;
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.form['preload'] = res.result;
    });
  }

  public maxFileSize = 1023000;
  /**
   * Upload Image
   * @param event
   */
  /**
   *
   * @param event
   * @param code
   * @param imageId
   */
  public onFileChangedDoc(event: any, code: string, imageId: any) {
    const fileObj = event.target.files[0];
    var _self = this;

    // if (fileObj.size > _self.maxFileSize) {
    //   _self.entryform['error'] = true;
    //   _self.entryform['message'] = 'File size should not exceed 5 MB' ;
    //   return;
    // }
    if (imageId === null || imageId === undefined) {
      imageId = 0;
    }
    let url = _self.getAPIBaseUrl(
      'doc/' + _self.entryform.data['id'] + '/' + imageId + '/' + code,
    );

    var param = {
      id: this.form.data.id,
    };
    this.locator.http.postMutipart(
      url,
      param,
      fileObj,
      function (res: any, error: any) {
        if (error) {
          alert(error);
          return;
        }
        _self.entryform.error = !res.success;
        _self.entryform.message = res.result.message;
        if (res.success) {
          _self.entryform.message = 'file is uploaded';
          _self.entryform.data[code] = res.result.data[code];
          _self.changeDoc();
          _self.getDoc(_self.form.data[code]);
        }
      },
    );
  }

  checkUserAccess(uiformId: any) {
    let _self = this;
    if (!uiformId && uiformId < 0) {
      return;
    }
    const keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    const roleId = localStorage.getItem(keySuffix + 'roleId');
    const appId = localStorage.getItem(keySuffix + 'appId');

    const searchParam = {
      applicationId: Number(appId),
      formId: Number(uiformId),
      applicationRoleId: Number(roleId),
    };

    _self.locator.config
      .getProperty('endpoint.application.role.usecase')
      .then((property: string) => {
        let url = property + '/search';

        this.locator.http.post(
          url,
          searchParam,
          function (res: any, error: any) {
            if (error) {
              console.log('Server Error:' + error);
              return;
            }

            if (res.success) {
              let templist = res.result.data;
              if (templist.length > 0) {
                _self.create = templist[0]['create'];
                _self.isDelete = templist[0]['delete'];
                _self.read = templist[0]['read'];
                _self.update = templist[0]['update'];
              }
            }
          },
        );
      });
  }

  checkBtnRight() {
    let _self = this;
    if (_self.form.data.buttons.length > 0) {
      _self.form.data.buttons.forEach((e: any, index: any) => {
        if (e.name === 'save') {
          if (_self.create == 0) {
            if (_self.update == 1) {
              if (_self.id != null && _self.id != 0) {
              } else {
                _self.form.data['buttons'].splice(index, 1);
              }
            } else {
              _self.form.data['buttons'].splice(index, 1);
            }
          }
        }
        if (e.name === 'new') {
          if (_self.create == 0) {
            _self.form.data['buttons'].splice(index, 1);
          }
        }
        if (e.name === 'list') {
          if (_self.read == 0) {
            _self.form.data['buttons'].splice(index, 1);
          }
        }
      });
    }
  }

  //--------------------------------------ADD PAGE COMMENT--------------------------------------

  commentform: any = {
    error: true,
    message: '',
    data: { id: 0 }, //form data
  };

  /**
   * Reset comment form
   */
  resetcommentForm(): void {
    this.commentform = {
      data: { id: 0 }, //form data
    };
    this.isSaving = false;
    this.isSaved = false;
  }

  /**
   * Add Page Comment
   */
  // public addPageComment() {
  //   let _self = this;

  //   _self.commentform['error'] = [];
  //   _self.commentform['message'] = '';
  //   _self.commentform['inputerror'] = [];

  //   _self.commentform['data']['applicationId'] = _self.usecase['appId'];
  //   _self.commentform['data']['userstoryId'] = _self.usecase['id']; //usecase id
  //   _self.commentform['data']['usecaseId'] = _self.usecase['id']; //usecase id
  //   _self.commentform['data']['formId'] = _self.uiformId; //form id
  //   _self.commentform['data']['recordId'] = _self.entryform['data']['id']; //record id

  //   let updatedName = _self.usecase['collectionName'].replace(/\./g, '/');

  //   let url = _self.urlRewrite(
  //     _self.locator.config.get('endpoint.api.v1') +
  //       '/' +
  //       updatedName +
  //       '/addComment'
  //   );

  //   _self.locator.http.post(
  //     url,
  //     _self.commentform['data'],
  //     function (res: any, error: boolean) {
  //       if (error) {
  //         alert('Server Error:' + error);
  //         return;
  //       }
  //       // _self.commentform['error'] = !res.success;
  //       // // _self.commentform['message'] = res.success;
  //       // _self.commentform['message'] = res.success
  //       //   ? 'Comment added successfully'
  //       //   : 'Failed to add comment';

  //       setTimeout(() => {
  //           if (res.success) {
  //           _self.commentform['error'] = !res.success;
  //        // _self.sform['message'] = res.success;
  //           _self.commentform['message'] = "Comment added successfully";
  //           }
  //           else{
  //           _self.commentform['error'] = res.success;
  //       // _self.sform['message'] = res.success;
  //           _self.commentform['message'] = "Failed to add comment";
  //           }
  //      }, 100); // 2000ms = 2 seconds

  //       if (res.result?.inputerror?.key) {
  //         _self.commentform['inputerror'] = res.result['inputerror']['key'];
  //       } else {
  //         _self.commentform['inputerror'] = res.result['inputerror'];
  //       }

  //       if (res.success) {
  //         _self.commentform['data']['id'] = res.result['data']['id'];
  //         _self.getCommentList(_self.id);
  //         //alert('Comment add successfully');
  //       }
  //     }
  //   );
  // }

  isSaving: boolean = false;
  isSaved: boolean = false;

  public addPageComment() {
    let _self = this;

    if (_self.isSaving || _self.isSaved) return; // Prevent multiple clicks

    _self.isSaving = true; // Disable the button while saving
    _self.commentform['error'] = [];
    _self.commentform['message'] = '';
    _self.commentform['inputerror'] = [];

    _self.commentform['data']['applicationId'] = _self.usecase['appId'];
    _self.commentform['data']['userstoryId'] = _self.usecase['id'];
    _self.commentform['data']['usecaseId'] = _self.usecase['id'];
    _self.commentform['data']['formId'] = _self.uiformId;
    _self.commentform['data']['recordId'] = _self.entryform['data']['id'];

    let updatedName = _self.usecase['collectionName'].replace(/\./g, '/');
    let url = _self.urlRewrite(
      _self.locator.config.get('endpoint.api.v1') +
        '/' +
        updatedName +
        '/addComment',
    );

    _self.locator.http.post(
      url,
      _self.commentform['data'],
      function (res: any, error: boolean) {
        _self.isSaving = false; // Stop loading

        if (error) {
          alert('Server Error:' + error);
          return;
        }

        _self.commentform['error'] = !res.success;
        _self.commentform['message'] = 'Comment added successfully';
        _self.isSaved = true;
        setTimeout(() => {
          if (res.success) {
            // _self.commentform['error'] = !res.success;
            // _self.commentform['message'] = "Comment added successfully";
            _self.isSaved = true; // Keep button disabled after save
            _self.getCommentList(_self.id);
          } else {
            _self.commentform['error'] = res.success;
            _self.commentform['message'] = 'Failed to add comment';
            _self.isSaving = false; // Allow user to retry
          }
        }, 1500);
      },
    );
  }

  /**
   * Get Comment List
   */
  public getCommentList(recordId: any) {
    let _self = this;
    let searchform: any = {};
    _self.commentform['error'] = [];
    _self.commentform['message'] = '';
    _self.commentform['inputerror'] = [];
    _self.commentList = [];

    searchform['applicationId'] = _self.usecase['appId'];
    searchform['userstoryId'] = _self.usecase['id']; //usecase id
    // searchform['usecaseId'] = _self.usecase['id']; //usecase id
    searchform['formId'] = _self.uiformId; //form id
    searchform['recordId'] = _self.id; //record id
    searchform['orderBy'] = 'modifiedDatetime';
    searchform['asc'] = 'DESC';

    let updatedName = _self.usecase['collectionName'].replace(/\./g, '/');

    let url =
      _self.locator.config.get('endpoint.api.v1') +
      '/cuickdev/page-comment/search';

    _self.locator.http.post(
      url,
      searchform,
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        //_self.commentform['error'] = !res.success;
        //_self.commentform['message'] = res.message;
        if (res.result?.inputerror?.key) {
          _self.commentform['inputerror'] = res.result['inputerror']['key'];
        } else {
          _self.commentform['inputerror'] = res.result['inputerror'];
        }

        if (res.success) {
          _self.commentList = res.result['data'];
        }
      },
    );
  }

  /**
   * Get Comment List
   */
  public getComment(recordId: any) {
    let _self = this;

    _self.commentform['error'] = [];
    _self.commentform['message'] = '';
    _self.commentform['inputerror'] = [];

    let updatedName = _self.usecase['collectionName'].replace(/\./g, '/');

    let url =
      _self.locator.config.get('endpoint.api.v1') +
      '/cuickdev/page-comment/get/' +
      recordId;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.commentform['error'] = !res.success;
      _self.commentform['message'] = res.message;
      if (res.result?.inputerror?.key) {
        _self.commentform['inputerror'] = res.result['inputerror']['key'];
      } else {
        _self.commentform['inputerror'] = res.result['inputerror'];
      }

      if (res.success) {
        _self.commentform['data'] = res.result['data'];
      }
    });
  }

  /**
   * Delete comment and update new list
   *
   * @param recordId
   * @param callback
   * @returns
   */
  public deleteComment(recordId: any, callback?: any) {
    let _self = this;

    if (recordId && recordId > 0) {
      if (_self.form.isConfirmDelete) {
        let flag = confirm('Are you sure ?');
        if (!flag) {
          return;
        }
      }

      _self.commentform['error'] = [];
      _self.commentform['message'] = '';
      _self.commentform['inputerror'] = [];

      let url =
        _self.locator.config.get('endpoint.api.v1') +
        '/cuickdev/page-comment/delete/' +
        recordId;

      _self.locator.http.get(url, function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }

        _self.commentform['error'] = !res.success;
        _self.commentform['message'] = res.message;

        if (res.result?.inputerror?.key) {
          _self.commentform['inputerror'] = res.result['inputerror']['key'];
        } else {
          _self.commentform['inputerror'] = res.result['inputerror'];
        }

        if (res.success) {
          _self.getCommentList(_self.id);
        }
      });
    }
  }

  //--------------------------------------Add Page Attachment--------------------------------------
  imageAttachmentPreview: string | ArrayBuffer | null = null;

  attachmentform: any = {
    error: true,
    message: '',
    data: { id: 0 }, //form data
  };

  /**
   * Reset attachment form
   */
  resetattachmentForm(): void {
    this.attachmentform = {
      data: { id: 0 }, //form data
    };
    this.imageAttachmentPreview = null;
    //this.showAttechmentInput=false;
    this.isSaving = false;
    this.isSaved = false;
    this.attfileObj = null;
    this.attForm['data'] = {};
  }

  /**
   * Add Page attachment
   */
  public addPageattachment() {
    let _self = this;

    _self.attachmentform['error'] = [];
    _self.attachmentform['message'] = '';
    _self.attachmentform['inputerror'] = [];

    _self.attachmentform['data']['applicationId'] = _self.usecase['appId'];
    _self.attachmentform['data']['userstoryId'] = _self.usecase['id']; //usecase id
    _self.attachmentform['data']['usecaseId'] = _self.usecase['id']; //usecase id
    _self.attachmentform['data']['formId'] = _self.uiformId; //form id
    _self.attachmentform['data']['recordId'] = _self.entryform['data']['id']; //record id

    let updatedName = _self.usecase['collectionName'].replace(/\./g, '/');

    let url = _self.urlRewrite(
      _self.locator.config.get('endpoint.api.v1') +
        '/' +
        updatedName +
        '/addattachment',
    );

    _self.locator.http.post(
      url,
      _self.attachmentform['data'],
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.attachmentform['error'] = !res.success;
        _self.attachmentform['message'] = 'attachment add successfully';
        if (res.result?.inputerror?.key) {
          _self.attachmentform['inputerror'] = res.result['inputerror']['key'];
        } else {
          _self.attachmentform['inputerror'] = res.result['inputerror'];
        }

        if (res.success) {
          _self.attachmentform['data']['id'] = res.result['data']['id'];
          _self.getattachmentList(_self.id);
          // alert('attachment add successfully');
        }
      },
    );
  }

  /**
   * Get attachment List
   */
  public getattachmentList(recordId: any) {
    let _self = this;
    let searchform: any = {};
    _self.attachmentform['error'] = [];
    _self.attachmentform['message'] = '';
    _self.attachmentform['inputerror'] = [];
    _self.attachmentList = [];

    searchform['applicationId'] = _self.usecase['appId'];
    searchform['userstoryId'] = _self.usecase['id']; //usecase id
    // searchform['usecaseId'] = _self.usecase['id']; //usecase id
    searchform['formId'] = _self.uiformId; //form id
    searchform['recordId'] = _self.id; //record id
    searchform['orderBy'] = 'modifiedDatetime';
    searchform['asc'] = 'DESC';

    let updatedName = _self.usecase['collectionName'].replace(/\./g, '/');

    let url =
      _self.locator.config.get('endpoint.api.v1') +
      '/cuickdev/page-attachment/search';

    _self.locator.http.post(
      url,
      searchform,
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        //_self.attachmentform['error'] = !res.success;
        //_self.attachmentform['message'] = res.message;
        if (res.result?.inputerror?.key) {
          _self.attachmentform['inputerror'] = res.result['inputerror']['key'];
        } else {
          _self.attachmentform['inputerror'] = res.result['inputerror'];
        }

        if (res.success) {
          _self.attachmentList = res.result['data'];
        }
      },
    );
  }

  /**
   * Get attachment List
   */
  public getattachment(recordId: any) {
    let _self = this;

    _self.attachmentform['error'] = [];
    _self.attachmentform['message'] = '';
    _self.attachmentform['inputerror'] = [];

    let updatedName = _self.usecase['collectionName'].replace(/\./g, '/');

    let url =
      _self.locator.config.get('endpoint.api.v1') +
      '/cuickdev/page-attachment/get/' +
      recordId;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.attachmentform['error'] = !res.success;
      _self.attachmentform['message'] = res.message;
      if (res.result?.inputerror?.key) {
        _self.attachmentform['inputerror'] = res.result['inputerror']['key'];
      } else {
        _self.attachmentform['inputerror'] = res.result['inputerror'];
      }

      if (res.success) {
        _self.attachmentform['data'] = res.result['data'];
      }
    });
  }

  /**
   * Delete attachment and update new list
   *
   * @param recordId
   * @param callback
   * @returns
   */
  public deleteattachment(recordId: any, callback?: any) {
    let _self = this;

    if (recordId && recordId > 0) {
      if (_self.form.isConfirmDelete) {
        let flag = confirm('Are you sure ?');
        if (!flag) {
          return;
        }
      }

      _self.attachmentform['error'] = [];
      _self.attachmentform['message'] = '';
      _self.attachmentform['inputerror'] = [];

      let url =
        _self.locator.config.get('endpoint.api.v1') +
        '/cuickdev/page-attachment/delete/' +
        recordId;

      _self.locator.http.get(url, function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }

        _self.attachmentform['error'] = !res.success;
        _self.attachmentform['message'] = res.message;

        if (res.result?.inputerror?.key) {
          _self.attachmentform['inputerror'] = res.result['inputerror']['key'];
        } else {
          _self.attachmentform['inputerror'] = res.result['inputerror'];
        }

        if (res.success) {
          _self.getattachmentList(_self.id);
        }
      });
    }
  }

  attForm: any = {
    data: {}, // data
  };

  attfileObj: any;

  setAttriForm() {
    var _self = this;
    _self.attForm = {
      id: _self.attachmentform.data?.id,
      applicationId: _self.usecase['appId'],
      userstoryId: _self.usecase['id'],
      usecaseId: _self.usecase['id'],
      formId: _self.uiformId,
      recordId: _self.entryform['data']['id'],
      description: _self.attachmentform['data']['description'],
    };
  }

  /**
   * Upload attatchment document
   * @param event
   */
  public onAttachmentformChanged(event: any) {
    var _self = this;
    _self.attfileObj = event.target.files[0];
    _self.showPreview(event);
    _self.attachmentform.message = '';
  }

  // showPreview(event: any) {
  // const target = event.target as HTMLInputElement;
  // const file = target.files ? target.files[0] : null;

  // if (file) {
  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     this.imageAttachmentPreview = reader.result; // Set the image preview
  //   };
  //   reader.readAsDataURL(file); // Convert the file to base64 URL
  // }
  // }

  showPreview(event: any) {
    const target = event.target as HTMLInputElement;
    const file = target.files ? target.files[0] : null;

    if (!file) return;

    const fileType = file.type;
    const fileName = file.name.toLowerCase();

    // Reset preview
    this.imageAttachmentPreview = null;

    if (fileType.startsWith('image/')) {
      //  Image preview
      const reader = new FileReader();
      reader.onload = () => {
        this.imageAttachmentPreview = reader.result;
      };
      reader.readAsDataURL(file);
    } else if (
      fileType === 'application/pdf' ||
      fileType === 'application/x-pdf' ||
      fileType === 'application/acrobat' ||
      fileType === 'applications/vnd.pdf' ||
      fileType === 'text/pdf' ||
      fileType === 'text/x-pdf' ||
      fileName.endsWith('.pdf')
    ) {
      //  PDF preview (optional: direct preview or icon)
      this.imageAttachmentPreview = 'assets/images/PDF_show.gif';
    } else if (
      fileType ===
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      fileType === 'application/msword'
    ) {
      //  Word file
      this.imageAttachmentPreview = 'assets/images/word_show.gif'; // or word.png icon path
    } else if (
      fileType === 'application/vnd.ms-excel' ||
      fileType ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      fileType === 'text/csv' ||
      fileName.endsWith('.xls') ||
      fileName.endsWith('.xlsx') ||
      fileName.endsWith('.csv')
    ) {
      this.imageAttachmentPreview = 'assets/images/excel_show.jpg'; // your Excel icon path
    }
  }
  attachmentLoading = false;

  saveAttachment() {
    var _self = this;
    if (_self.isSaving) return; // Prevent multiple clicks
    _self.isSaving = true; // Disable the button

    let url = _self.getAPIBaseUrl('addAttechment');
    _self.setAttriForm();

    if (!_self.attfileObj || _self.attfileObj.length === 0) {
      const formData = new FormData();
      formData.append('id', this.attForm.id || '');
      formData.append('applicationId', this.attForm.applicationId || '');
      formData.append('userstoryId', this.attForm.userstoryId);
      formData.append('formId', this.attForm.formId);
      formData.append('recordId', this.attForm.recordId);
      formData.append('description', this.attForm.description);

      if (this.attfileObj && this.attfileObj.length > 0) {
        formData.append('file', this.attfileObj[0]);
      }

      this.locator.http.post(
        url,
        formData,
        function (res: any, error: boolean) {
          if (error) {
            alert('Server Error:' + error);
            _self.isSaving = false; // Re-enable button if error occurs
            return;
          }
          _self.attachmentform.message = 'Attachment added successfully';
          _self.attachmentform['error'] = !res.success;

          if (res.success) {
            _self.attachmentform['data'] = res.result['data'];
            //_self.changeDoc();
          }

          setTimeout(() => {
            if (res.success) {
              _self.getattachmentList(_self.id);
            } else {
              _self.attachmentform['error'] = res.success;
              _self.attachmentform['message'] = 'Failed to add attachment';
              _self.isSaving = false; // Re-enable button if error occurs
            }
          }, 1500);
        },
      );
      return;
    }

    this.locator.http.postMutipart(
      url,
      _self.attForm,
      _self.attfileObj,
      function (res: any, error: any) {
        if (error) {
          alert(error);
          _self.isSaving = false;
          return;
        }

        _self.attachmentform.message = 'Attachment added successfully';
        _self.attachmentform['error'] = !res.success;

        if (res.success) {
          _self.attachmentform['data'] = res.result['data'];
          _self.changeDoc();
        }

        setTimeout(() => {
          if (res.success) {
            _self.getattachmentList(_self.id);
          } else {
            _self.attachmentform['error'] = res.success;
            _self.attachmentform['message'] = 'Failed to add attachment';
            _self.isSaving = false; // Re-enable button if error occurs
          }
        }, 1500);
      },
    );
  }

  /**
   * Upload attatchment document
   * @param event
   */

  getInitials(fullName: string): string {
    if (!fullName) return '';

    // Split the name at uppercase letters or space
    const words = fullName.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ');

    // Get the first character of the first and second words (if available)
    const initials = words
      .slice(0, 2)
      .map((word) => word.charAt(0).toUpperCase())
      .join('');

    return initials;
  }

  public datavalidate = false;
  public btnDisable = true;

  checkEmail(email: any) {
    let _self = this;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(email)) {
      console.error('Email is not valid');
      _self.form.error = true;
      _self.datavalidate = true;
      _self.btnDisable = true; // ❗ Disable the button when email is invalid
      _self.form.inputerror['email'] = 'Email not valid';
      return;
    } else {
      _self.form.error = false;
      _self.datavalidate = false;
      _self.btnDisable = false; // ✅ Enable the button when email is valid
    }
  }

  trackByFn(index: number, item: any) {
    return item.id;
  }
  setDefaultvalue() {
    this.usecaseAttributes.forEach((item: any) => {
      if (
        (item.type === 'date' || item.type === 'idate') &&
        item.defaultToCurrentDate
      ) {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const year = now.getFullYear();
        const formattedDate = `${year}-${month}-${day}`;
        this.entryform.data[item.code] = formattedDate;
      }
      if (item.type === 'time' && item.defaultToCurrentTime) {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const formattedTime = `${hours}:${minutes}`;
        this.entryform.data[item.code] = formattedTime;
      }
      if (item.type === 'dateandtime' && item.defaultToCurrentDateAndTime) {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const year = now.getFullYear();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const formattedDateAndTime = `${year}-${month}-${day} ${hours}:${minutes}`;
        this.entryform.data[item.code] = formattedDateAndTime;
      }
      if (item.type === 'itime' && item.defaultToCurrentItime) {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const formattedITime = `${hours}:${minutes}`;
        this.entryform.data[item.code] = formattedITime;
      }

      if (item.defaultValue) {
        this.entryform.data[item.code] = item.defaultValue;
      }
    });
  }

  defaultLat = 28.6139;
  defaultLng = 77.209;
  activeMapCode: string | null = null;

  setCurrentLocation(code: string) {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          if (!this.entryform.data[code]) {
            this.entryform.data[code] = {};
          }

          this.entryform.data[code].lat = lat;
          this.entryform.data[code].lng = lng;
        },
        (error) => {
          console.error('❌ Geolocation error:', error);
          alert(
            'Unable to get your location. Please allow location access in the browser.',
          );
        },
      );
    } else {
      alert('Geolocation is not supported by your browser.');
    }
  }

  viewOnMap(code: string) {
    const location = this.entryform.data[code];
    const lat = location?.lat;
    const lng = location?.lng;

    if (lat && lng) {
      const mapUrl = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(mapUrl, '_blank');
    } else {
      alert('Location not available. Please set the location first.');
    }
  }

  clearLocation(code: string) {
    if (this.entryform.data[code]) {
      this.entryform.data[code].lat = null;
      this.entryform.data[code].lng = null;
    }
  }

  enforceMaxDate(event: Event, fieldCode: string, fieldType: string): void {
    if (fieldType === 'date') {
      const input = event.target as HTMLInputElement;
      const maxDate = new Date('9999-12-31');
      const enteredDate = new Date(input.value);
      // If invalid or too large, reset
      if (enteredDate > maxDate) {
        input.value = '9999-12-31';
        this.entryform.data[fieldCode] = '9999-12-31';
      } else {
        this.entryform.data[fieldCode] = input.value;
      }
    }
  }

  imageFiles: { [key: string]: File } = {};
  docFiles: { [key: string]: File } = {};

  imagePreviews: { [key: string]: string | ArrayBuffer | null } = {};
  fileErrors: { [key: string]: boolean } = {};
  imageSizes: { [key: string]: boolean } = {};

  uploadFileToServer(file: File, code: string, imageId: any): Promise<any> {
    if (imageId === null || imageId === undefined) {
      imageId = 0;
    }

    const url = this.getAPIBaseUrl(
      `doc/${this.entryform.data['id']}/${imageId}/${code}`,
    );
    const param = { id: this.form.data.id };

    return new Promise((resolve, reject) => {
      this.locator.http.postMutipart(
        url,
        param,
        file,
        (res: any, error: any) => {
          if (error) {
            reject(error);
          } else {
            this.entryform.error = !res.success;
            this.entryform.message = res.result.message;
            if (res.success) {
              this.entryform.message = 'File is uploaded';
              this.entryform.data[code] = res.result.data[code];
              this.changeDoc();
              this.getDoc(this.entryform.data[code]);
              this.cdRef.detectChanges();
            }
            resolve(res);
          }
        },
      );
    });
  }

  DocPreviews: { [key: string]: string | ArrayBuffer | null } = {};

  //------show Password---------
  showPassword: boolean = false;

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  editors: { [key: string]: Editor } = {};
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  generateHtmlFromEditor(code: string): void {
    const value = this.form.data[code];
  }
  getSanitizedHtml(html: any): SafeHtml {
    if (html && typeof html === 'object' && html.type === 'doc') {
      try {
        html = toHTML(html);
      } catch (err) {
        html = '';
      }
    }

    if (typeof html !== 'string') {
      html = String(html ?? '');
    }

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  removeHTMLTags(html: string): string {
    if (!html) return '';
    const div = document.createElement('div'); // Temporary element banayenge
    div.innerHTML = html; // HTML inject karenge
    return div.textContent || div.innerText || ''; // Sirf text milega, no tags
  }

  destroyHtmlEditor() {
    if (this.editors) {
      Object.keys(this.editors).forEach((key: string) => {
        const editor = this.editors[key];
        if (editor && typeof editor.destroy === 'function') {
          editor.destroy();
        }
        // Also clear the underlying textarea or div content
        const element = document.getElementById(
          key,
        ) as HTMLTextAreaElement | null;
        if (element) {
          element.value = ''; // If it's a textarea
          element.innerHTML = ''; // If it's a div or contenteditable
        }
      });
    }
    this.editors = {};
  }
  setHtmlEditor() {
    var _self = this;
    _self.usecaseAttributes?.forEach((e: any) => {
      if (e.type === 'textarea' && e.enableEditor === 1) {
        _self.editors[e.code] = new Editor();
      }
    });
  }

  // onFileChooseClicked(fileInput: any, code: any) {
  //   if (fileInput) {
  //     fileInput.value = '';
  //   }
  //   this.imageSizes[code] = false;
  //   this.imagePreviews[code] = null;
  //   this.fileErrors[code] = false;
  // }

  // onImageFileChanged(event: any, e: any, imageId: any) {
  //   console.log('e-->', e);
  //   let code = e.code;
  //   // console.log("code",e.size);

  //   const file = event.target.files[0];
  //   if (!file) return;
  //   // Validate file type
  //   const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
  //   if (!allowedTypes.includes(file.type)) {
  //     this.fileErrors[code] = true;
  //     this.imageSizes[code] = false;
  //     this.imagePreviews[code] = null;
  //     return;
  //   } else {
  //     this.fileErrors[code] = false;
  //   }

  //   if (e.size) {
  //     const maxSizeImg = e.size;
  //     const maxFileSizeInBytes = maxSizeImg * 1024 * 1024;

  //     if (file.size > maxFileSizeInBytes) {
  //       this.imageSizes[code] = true;
  //       this.fileErrors[code] = false;
  //       this.imagePreviews[code] = null;
  //       return;
  //     } else {
  //       this.imageSizes[code] = false;
  //     }
  //   } else {
  //     // No size restriction
  //     console.log('No size limit specified, allowing any image size.');
  //     this.imageSizes[code] = false;
  //   }

  //   // Step 1: Show Preview First
  //   const reader = new FileReader();
  //   reader.onload = (e) => {
  //     this.imagePreviews[code] = e.target?.result as string;
  //     this.cdRef.detectChanges();
  //     this.imageFiles[code] = file;
  //   };
  //   reader.readAsDataURL(file);
  // }

  docFileErrors: { [key: string]: boolean } = {};
  docSizes: { [key: string]: boolean } = {};

  public onFileChanged(event: any, e: any, imageId: any) {
    const code = e.code;
    const fileObj = event.target.files[0];
    var _self = this;
    if (imageId === null || imageId === undefined) {
      imageId = 0;
    }

    const allowedDocTypes = [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/gif',
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel', // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ];

    if (!allowedDocTypes.includes(fileObj.type)) {
      this.docFileErrors[code] = true;
      this.docSizes[code] = false;
      this.DocPreviews[code] = null;
      return;
    } else {
      this.docFileErrors[code] = false;
    }

    const maxSizeDoc = e.size || 1;
    const maxFileSizeInBytes = maxSizeDoc * 1024 * 1024;
    if (fileObj.size > maxFileSizeInBytes) {
      this.docSizes[code] = true;
      this.docFileErrors[code] = false;
      this.DocPreviews[code] = null;
      return;
    } else {
      this.docSizes[code] = false;
    }
    this.docFiles[code] = fileObj;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.DocPreviews[code] = e.target?.result as string;
      this.cdRef.detectChanges();
      this.docFiles[code] = fileObj;
    };
    reader.readAsDataURL(fileObj);
  }

  resetHtmlData() {
    this.attributeList?.forEach((e: any) => {
      if (e.type === 'textarea' && e.enableEditor === 1) {
        this.form.data[e.code] = '';
        const editorInstance = this.editors[e.code];
        if (editorInstance) {
          editorInstance.setContent('');
        }
      }
    });
  }
  prepareLocationField(code: string): void {
    const value = this.entryform.data[code];

    if (value && typeof value === 'string') {
      try {
        const cleaned = value
          .replace(/lat\s*:\s*/i, '"lat":')
          .replace(/lng\s*:\s*/i, '"lng":')
          .replace(/'/g, '"');

        this.entryform.data[code] = JSON.parse(`{${cleaned}}`);
      } catch (e) {
        console.error('Invalid location string for code:', code, value);
        this.entryform.data[code] = null;
      }
    }
  }

  effectiveFormId: any;

  checkAddOnRule() {
    let _self = this;

    const keySuffix = localStorage.getItem('keySuffix');

    const ruleDataString = localStorage.getItem(keySuffix + 'ruleData');
    const ruleData: { [key: number]: string } = ruleDataString
      ? JSON.parse(ruleDataString)
      : {};
    let currentFormId: any = _self.uiformId;
    const ruleStatus = ruleData[currentFormId];

    // Default: use current uiformId
    _self.effectiveFormId = currentFormId;
    if (ruleStatus == 'Yes') {
      const url = _self.urlRewrite(_self.getAPIBaseUrl('fetchRule'));

      _self.locator.http.post(
        url,
        { formId: currentFormId },
        function (res: any, error: boolean) {
          if (error) {
            alert('Server Error: ' + error);
            return;
          }

          const updatedFormID = res?.result?.data?.updatedFormID;

          if (updatedFormID) {
            _self.effectiveFormId = updatedFormID;
          }
        },
      );
    }
  }

  getFilteredData(data: any[]) {
    return data;
  }
  compareFn = (item1: any, item2: any) => {
    if (!item1 || !item2) return false;
    const id1 = typeof item1 === 'object' ? item1.id : item1;
    const id2 = typeof item2 === 'object' ? item2.id : item2;
    return id1.toString() === id2.toString();
  };
  filterFn = (term: string, item: any) => {
    if (!term) return true;
    term = term.toLowerCase();
    return item._val?.toLowerCase().includes(term);
  };
  resetChildren(parentCode: string) {
    const allChildren = this.getAllChildren(parentCode);

    allChildren.forEach((code) => {
      // delete the value
      delete this.entryform.data[code];
      // ALSO delete dependent mapped attribute
      // const childField = this.usecaseAttributes.find((f:any) => f.code === code);
      // if (childField?.depAttribute) {
      //     delete this.entryform.data[childField.depAttribute];
      // }
    });

    this.cdRef.detectChanges();
  }

  getAllChildren(parentCode: string): string[] {
    let children: string[] = [];

    this.usecaseAttributes.forEach((f: any) => {
      if (f.parentUsecaseDependency) {
        const parentDep = f.parentUsecaseDependency;
        const parentOfChild = (
          parentDep && (Object.values(parentDep)[0] as any)
        )?.id;

        if (parentOfChild === parentCode) {
          children.push(f.code);

          // recursive grandchildren
          const grandChildren = this.getAllChildren(f.code);

          if (grandChildren.length > 0) {
            console.log(`➡️ Grandchildren of ${f.code}:`, grandChildren);
          }

          children.push(...grandChildren);
        }
      }
    });
    this.cdRef.detectChanges();
    return children;
  }

  getAppDocThumbnail(skey: number) {
    let _self = this;
    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    let appLogoId = localStorage.getItem(keySuffix + 'appLogoId');
    if (!skey) {
      if (appLogoId) {
        skey = Number(appLogoId);
      } else {
        skey = 0;
      }
    }
    let docAPI = this.locator.config.get('DOC_API');
    let url = docAPI + 'th/' + skey + '?t=' + this.imageTimestamp;

    return url;
  }

  /**
   * Get application doc
   * @param skey
   */
  getAppDoc(skey: number) {
    let _self = this;
    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    let appLogoId = localStorage.getItem(keySuffix + 'appLogoId');
    if (!skey) {
      if (appLogoId) {
        skey = Number(appLogoId);
      } else {
        skey = 0;
      }
    }
    return _self.getDoc(skey);
  }

  // -----------------Image Crop Function--------------------------

  imageChangedEvent: any = '';
  croppedImage: string = '';
  activeCode: string = ''; // store which field is being cropped
  showCropper: boolean = false;
  transform: ImageTransform = {
    translateUnit: 'px',
    scale: 1,
    rotate: 0,
    flipH: false,
    flipV: false,
    translateH: 0,
    translateV: 0,
  };

  loading = false;
  canvasRotation = 0;
  cropperMinWidth = 0;
  cropperMinHeight = 0;
  cropperMaxWidth = 0;
  cropperMaxHeight = 0;
  cropperStaticWidth = 0;
  cropperStaticHeight = 0;
  containWithinAspectRatio = false;
  maintainAspectRatio = false;
  resetCropOnAspectRatioChange = true;
  aspectRatio = 4 / 3;
  alignImage = 'center' as const;
  roundCropper = false;
  hidden = false;
  disabled = false;
  hideResizeSquares = false;

  // fileErrors: { [key: string]: boolean } = {};
  // imageSizes: { [key: string]: boolean } = {};
  // imagePreviews: { [key: string]: string } = {};

  // open modal when file selected
  openCropperModal(event: any, code: string): void {
    const file = event.target.files[0];
    if (!file) return;

    // validate type
    const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
    if (!validTypes.includes(file.type)) {
      this.fileErrors[code] = true;
      return;
    }
    this.fileErrors[code] = false;

    // validate size (1MB default)
    const maxSize = 1024 * 1024 * 1; // 1 MB
    if (file.size > maxSize) {
      this.imageSizes[code] = true;
      return;
    }
    this.imageSizes[code] = false;

    // set active field and open cropper
    this.activeCode = code;
    this.imageChangedEvent = event;
    this.showCropper = true;

    // open Bootstrap modal manually
    const modal: any = document.getElementById('imageModal');
    if (modal) {
      const bsModal = new (window as any).bootstrap.Modal(modal);
      bsModal.show();
    }
  }

  imageCropped(event: any) {
    console.log('Cropped event:', event);

    if (event && event.base64) {
      this.croppedImage = event.base64;
    } else if (event && event.blob) {
      // Convert blob to base64
      const reader = new FileReader();
      reader.onload = () => {
        this.croppedImage = reader.result as string; // now croppedImage is set
      };
      reader.readAsDataURL(event.blob);
    }
  }

  imageLoaded() {
    console.log('Image loaded ');
  }
  cropperReady(event?: any) {
    console.log('Cropper ready', event);
  }
  loadImageFailed() {
    console.error('Load failed ');
  }

  // cancel crop
  cancelCrop() {
    this.showCropper = false;
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.activeCode = '';
  }

  // save cropped
  saveCroppedImage() {
    if (this.croppedImage && this.activeCode) {
      this.imagePreviews[this.activeCode] = this.croppedImage;

      // convert to file and update entryform
      const file = this.base64ToFile(this.croppedImage, 'cropped.png');

      if (!this.entryform.data) {
        this.entryform.data = {};
      }

      this.entryform.data[this.activeCode] = file;
      // important: keep consistency with onImageFileChanged
      this.imageFiles[this.activeCode] = file;

      console.log('Saved file for code:', this.activeCode, file);
    }

    this.cancelCrop();
  }

  // helper
  private base64ToFile(data: string, filename: string): File {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/png';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  // Add inside your UiformEditComponent class
  onFileChooseClicked(file: any, code: string): void {
    console.log('File choose clicked:', code);
  }

  onImageFileChanged(event: any, e: any, code: string): void {
    console.log('Image file changed:', code, event);
    //  this.onFileChanged(event, code); // reuse existing method if you want
  }

  zoomIn() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! + 0.1,
    };
  }

  zoomOut() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! - 0.1,
    };
  }

  rotateRight() {
    this.loading = true;
    setTimeout(() => {
      this.canvasRotation++;
      this.flipAfterRotate();
    });
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH,
      translateH: 0,
      translateV: 0,
    };
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH,
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV,
    };
  }

  rotateLeft() {
    this.loading = true;
    setTimeout(() => {
      // Use timeout because rotating image is a heavy operation and will block the ui thread
      this.canvasRotation--;
      this.flipAfterRotate();
    });
  }

  //----------------------------------------------------------------------Expression Excel Functionality------------------------------>

  evaluateExpressionFieldsBeforeSave() {
    if (!this.form || !this.entryform?.data) {
      return;
    }

    const allFields: any[] = this.usecaseAttributes || [];

    // Run a few passes to handle chained expressions (A depends on B, B depends on C, etc.)
    let updated = true;
    let iteration = 0;

    while (updated && iteration < 3) {
      updated = false;
      iteration++;

      for (const field of allFields) {
        if (field.type === 'expression' && field.expression) {
          let expr: string = field.expression;
          const dependencies: string[] = (expr.match(/@\w[\w\s]*/g) || []).map(
            (d: string) => d.trim().replace('@', ''),
          );

          // ✅ Check if all dependent fields are filled
          const allDepsFilled = dependencies.every((dep: string) => {
            const depField = allFields.find((f: any) => f.label.trim() === dep);
            const depValue = depField
              ? this.entryform.data[depField.code]
              : null;
            return (
              depValue !== undefined && depValue !== null && depValue !== ''
            );
          });

          if (!allDepsFilled) {
            continue;
          }

          // ✅ Replace @labels with actual field values
          for (const f of allFields) {
            const labelKey = `@${f.label}`;
            let value = this.entryform.data[f.code];
            if (value === undefined || value === null || value === '')
              value = 0;
            expr = expr.replaceAll(labelKey, value);
          }

          try {
            const result = Function('"use strict";return (' + expr + ')')();
            this.entryform.data[field.code] = result;
            updated = true;
          } catch (err) {
            console.error(`❌ Failed to evaluate ${field.code}:`, err);
          }
        }
      }
    }
  }

  evaluateExpressionFieldsNumberBeforeSave() {
    console.log('Hello world i am here');

    if (!this.form || !this.entryform?.data) {
      return;
    }

    const allFields: any[] = this.usecaseAttributes || [];

    let updated = true;
    let iteration = 0;

    while (updated && iteration < 3) {
      updated = false;
      iteration++;

      for (const field of allFields) {
        if (field.type === 'expression' && field.expression) {
          let originalExpr: string = field.expression;
          let expr: string = originalExpr;

          // 1. Extract Dependencies
          const dependencies: string[] = (expr.match(/@\w[\w\s]*/g) || []).map(
            (d: string) => d.trim().replace('@', ''),
          );

          // 2. Identify empty/missing dependencies
          const emptyDependencies: string[] = [];

          for (const dep of dependencies) {
            const depField = allFields.find((f: any) => f.label.trim() === dep);
            const depValue = depField
              ? this.entryform.data[depField.code]
              : null;

            // If the dependency value is empty, null, or undefined, add it to the empty list
            if (
              depValue === undefined ||
              depValue === null ||
              String(depValue).trim() === ''
            ) {
              emptyDependencies.push(dep);
            }
          }

          // 3. Dynamically RESTRICT the Expression
          // Remove empty dependency labels along with the preceding operator (+, -, *, /)
          if (emptyDependencies.length > 0) {
            for (const emptyDep of emptyDependencies) {
              const labelKey = `@${emptyDep}`;

              // Regular Expression to find the operator and the label, and remove both.
              // It looks for a math operator (+, -, *, /) followed by the field label.
              // We make the operator optional for the first term.
              const removalRegex = new RegExp(
                `[\\+\\-\\*/]?\\s*${labelKey}`,
                'g',
              );

              expr = expr.replace(removalRegex, '');
            }

            // Clean up any remaining leading/trailing operators or redundant spaces.
            // This is crucial to avoid expressions like * 25 + 32 (if the first field was removed).
            expr = expr
              .trim()
              .replace(/^[\+\-\*/]/, '')
              .trim();
          }

          // 4. Replace remaining @labels with their actual values (as strings for replacement)
          for (const f of allFields) {
            const labelKey = `@${f.label}`;
            let value = this.entryform.data[f.code];

            // Use the number value for substitution
            let numericValue = Number(value);
            if (isNaN(numericValue)) {
              numericValue = 0;
            }

            // FIX: Convert the number to a string for replacement
            expr = expr.replaceAll(labelKey, String(numericValue));
          }

          // 5. Run the Calculation
          try {
            // If the entire expression became empty (e.g., all fields were empty)
            if (expr.length === 0) {
              this.entryform.data[field.code] = null;
              updated = true;
              continue;
            }

            const result = Function('"use strict";return (' + expr + ')')();

            // Handle potential NaN/Infinity, set to null
            const finalResult =
              isNaN(result) ||
              !isFinite(result) ||
              result === null ||
              result === undefined
                ? null
                : result;

            if (this.entryform.data[field.code] !== finalResult) {
              this.entryform.data[field.code] = finalResult;
              updated = true;
            }
          } catch (err) {
            console.error(
              `❌ Failed to evaluate ${field.code}: Expression: "${expr}"`,
              err,
            );

            if (this.entryform.data[field.code] !== null) {
              this.entryform.data[field.code] = null;
              updated = true;
            }
          }
        }
      }
    }
  }

  /**
   *
   * @param event
   * @param e
   * @param placeValue
   * @returns
   */
  restrictDecimalPlaces(event: Event, e: any, placeValue: number): void {
    const input = event.target as HTMLInputElement;
    if (!input.value) {
      this.evaluateExpressionFieldsNumberBeforeSave();
      return;
    }
    const value = input.value;
    const parts = value.split('.');

    if (parts.length === 2 && parts[1].length > placeValue) {
      this.entryform['error'] = true;
      this.entryform['message'] =
        'Only ' + placeValue + ' decimal value allowed on ' + e.label;
      this.entryform.data[e.code] = `${parts[0]}.${parts[1].substring(
        0,
        placeValue,
      )}`;
      input.value = `${parts[0]}.${parts[1].substring(0, placeValue)}`;
    }

    this.evaluateExpressionFieldsNumberBeforeSave();
  }

  //--------------------------------implementing list as radio button and checkbox ----------------//
  onRadioChange(attribute: any, option: string): void {
    this.entryform.data[attribute.code] = option;
  }

  onListCheckboxChange(attribute: any, option: string, event: any): void {
    const isChecked = event.target.checked;
    const model = this.form.data[attribute.code];

    if (!Array.isArray(model)) {
      this.form.data[attribute.code] = [];
    }

    if (isChecked) {
      if (!this.form.data[attribute.code].includes(option)) {
        this.form.data[attribute.code].push(option);
      }
    } else {
      const index = this.form.data[attribute.code].indexOf(option);
      if (index > -1) {
        this.form.data[attribute.code].splice(index, 1);
      }
    }
  }

  public convertIntoLocalDate(utc: any) {
    if (!utc) return null;
    const d = new Date(utc);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    const date = `${year}-${month}-${day}`;
    return date;
  }
}
